import fetch from 'unfetch'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory'
import { getGraphqlEndpointUrl } from '@/helpers/url'

export const FETCH_POLICY = {
  cacheFirst: 'cache-first',
  cacheAndNetwork: 'cache-and-network',
  networkOnly: 'network-only',
  cacheOnly: 'cache-only',
  noCache: 'no-cache',
}

let client
if (!window.IS_MAIN_APP) {
  // TODO: B2C-2110
  // Customer service app is using main app navigation and
  // gql queries will fail because customer service app does not have the same graphql endpoint.
  // Therefore, we return a mock, if customer service app was detected.
  client = {
    query: () => new Promise(() => {}),
    mutate: () => new Promise(() => {}),
  }
} else {
  const cache = new InMemoryCache({
    // By default, the InMemoryCache attempts to generate a unique identifier for an object
    // by combining the object's __typename field with its id or _id field.
    // In dataIdFromObject you can overwrite default behaviour for certain types.
    dataIdFromObject: object => {
      switch (object.__typename) {
        case 'Order':
          return `Order:${object.number}`
        case 'PrefilledNewsletterCheckbox':
          return `PrefilledNewsletterCheckbox:${object.email}`
        case 'ContentfulAsset':
          return `ContentfulAsset:${object.title}`
        default:
          return defaultDataIdFromObject(object)
      }
    },
  })

  client = new ApolloClient({
    link: new HttpLink({ uri: getGraphqlEndpointUrl(), fetch }),
    cache,
    headers: {
      'On-Client': 'frontend',
      'Content-Type': 'application/json',
    },
  })
}

export default client
